module.exports = __webpack_public_path__ + "img/supra-iliaca.d5851550.png";